import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from '../Icon';

import styles from './styles/index.module.scss';

const hasNoValue = value => value === '';

const InputClose = ({ value, closeIconId, onClick, onKeyDown }) => {
  const className = cn({
    [styles.inputClose]: true,
    [styles.iconCloseHidden]: hasNoValue(value),
  });

  return (
    <span
      className={className}
      id={closeIconId}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role="button"
    >
      <Icon
        id="close"
        fill="#000"
        size="22"
        className={styles.inputCloseIcon}
      />
    </span>
  );
};

InputClose.propTypes = {
  value: PropTypes.string.isRequired,
  closeIconId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
};

export default InputClose;
